import HttpClient from '../HttpClient/LegacyApi';
import { map, concatAll, toArray } from "rxjs/operators";
import { of } from "rxjs";
import Grain from "../ReadModels/Grain";
import ProcessingEnterprise from "../ReadModels/ProcessingEnterprise";
import Region from "../ReadModels/Region";

export default {
    getActual() {

        return HttpClient.get(`/processing-enterprises/actual`)
            .pipe(
                map(response => response.data),
                concatAll(regions => of(regions)),
                map((region) => {

                    var grains = region.grains.map((grain) => {
                        var enterprises = grain.enterprises.map(enterprise => {
                            return new ProcessingEnterprise(
                                enterprise.id,
                                enterprise.name,
                                enterprise.lastCall,
                                enterprise.grainPrice,
                                enterprise.expirationContractDate,
                                enterprise.willExpireSoon,
                            );
                        });
                        return new Grain(grain.id, grain.name, enterprises);
                    });

                    return new Region(
                        region.id,
                        region.name,
                        grains
                    );
                }),
                toArray(),
            );
    }
}



// WEBPACK FOOTER //
// ./apiClient/ProcessingEnterpriseHttpAdapter/index.js